// src/utils/holderResolver.js

import {
    HOLDER_TYPES,
    HOLDER_ID_FIELDS,
    HOLDER_NAME_FIELDS
} from "../constants/holderTypes";

import {
    normalizeHolderType
} from "./assets/holderUtils";

/**
 * Normalize safely
 */
const normalize = (value) => {

    return String(value || "")
        .trim()
        .toLowerCase();

};

/**
 * Get possible ID fields
 */
const getIdFields = (holderType) => {

    return (
        HOLDER_ID_FIELDS[
            normalizeHolderType(
                holderType
            )
        ] || []
    );

};

/**
 * Get possible display name fields
 */
const getNameFields = (holderType) => {

    return (
        HOLDER_NAME_FIELDS[
            normalizeHolderType(
                holderType
            )
        ] || []
    );

};

/**
 * Validate holder type
 */
export const isValidHolderType = (
    holderType
) => {

    return Object.values(
        HOLDER_TYPES
    ).includes(
        normalizeHolderType(
            holderType
        )
    );

};

/**
 * Resolve holder safely
 */
export const resolveHolder = ({
    holderType,
    holderId,
    collection = []
}) => {

    if (
    !holderType ||
    !Array.isArray(collection)
) {
    return null;
}

// STORE fallback support
if (
    normalizeHolderType(holderType) ===
        HOLDER_TYPES.STORE &&
    !holderId
) {

    return {
        store_name: "MAIN STORE",
        holder_name: "MAIN STORE"
    };

}

    const normalizedLookupId =
        normalize(holderId);

    const idFields =
        getIdFields(holderType);

    const matchedHolder =
        collection.find((item) => {

            return idFields.some((field) => {

                return (
                    normalize(
                        item?.[field]
                    ) ===
                    normalizedLookupId
                );

            });

        });

    return matchedHolder || null;

};

/**
 * Resolve holder display name
 */
export const getHolderDisplayName = ({
    holderType,
    holderId,
    collection = []
}) => {

    const holder = resolveHolder({
        holderType,
        holderId,
        collection
    });

    if (!holder) {

    if (
        normalizeHolderType(holderType) ===
        HOLDER_TYPES.STORE
    ) {
        return "MAIN STORE";
    }

    return "";

}

    const nameFields =
        getNameFields(holderType);

    for (const field of nameFields) {

        const value =
            holder?.[field];

        if (value) {

            return String(value)
                .trim();

        }

    }

    return "";

};

/**
 * Snapshot-first holder label resolver
 */
export const getResolvedHolderLabel = ({
    asset = {},
    collection = []
}) => {

    // ==========================================
    // 1. HOLDER SNAPSHOT PRIORITY
    // ==========================================

    if (
        asset?.holder_snapshot
            ?.holder_name
    ) {

        return asset
            .holder_snapshot
            .holder_name;

    }

    // ==========================================
    // 2. CURRENT HOLDER FALLBACK
    // ==========================================

    return getHolderDisplayName({

        holderType:
            asset?.current_holder_type,

        holderId:
            asset?.current_holder_id,

        collection

    });

};

/**
 * Safe holder existence check
 */
export const holderExists = ({
    holderType,
    holderId,
    collection = []
}) => {

    const holder =
        resolveHolder({
            holderType,
            holderId,
            collection
        });

    return !!holder;

};